import type { IconToken } from '@core/user-interface-legacy';
import type { AskTicketPriority } from '@tellent-ask-hr/tickets-types';

export const priorityColorMap: Record<AskTicketPriority, IconToken> = {
  low: 'colorIconDisabled',
  normal: 'colorIconInfoDefault',
  high: 'colorIconWarningDefault',
  urgent: 'colorIconCriticalStrongDefault',
};
